<template>
    <el-container class="snapshot-board">
        <el-main>
            <div class="snapshot-title column-header">
                <span>快照看板</span>
                <el-button class="btn__style" @click="backList">返回</el-button>
            </div>
            <div class="snapshot-board-body">
                <div class="asset-total" v-if="apiStatics">      
                    <div class="asset-total-box">
                        <div class="asset-total-title" title="减去了用于抵押的价值">
                            <div class="asset-title-item">
                                <span>净资产（USDT）: </span>
                                <span>{{apiStatics['total_equity(USDT)']}}</span>
                            </div>
                            <div class="asset-title-item">
                                <span>本金价值（USDT）: </span>
                                <span>{{apiStatics['principal/surplus(USDT)']}}</span>
                            </div>
                            <div class="asset-title-item">
                                <span>总持仓：</span>
                                <span>{{apiStatics['total_position']}}</span>
                            </div>
                        </div>
                        <div class="asset-total-body">
                            <div class="asset-total-item" v-if="calUsedRate">
                                <span class="asset-item-name">(期货已用+抵押已用)/总净资产：</span>
                                <span class="asset-item-progress"><NewProgress :myWidth="180" :myHeight="18" :typeNum='1' :progressWidth="calUsedRate"></NewProgress></span>
                                <span class="assets-item-value">({{calUsedRate['future']}}+{{calUsedRate['borrow']}})/{{calUsedRate['total']}}</span>
                            </div>
                            <div class="asset-total-item">
                                <span class="asset-item-name">净总资产已用/闲置/总净资产：</span>
                                <span class="asset-item-progress"><MyProgress :myWidth="180" :myHeight="18" :typeNum='1' :proressWidth="apiStatics['total_used/surplus(USDT)']"></MyProgress></span>
                                <span class="assets-item-value">{{dataProcess(apiStatics['total_used/surplus(USDT)'])}}</span>
                            </div>
                            <div class="asset-total-item">
                                <span class="asset-item-name">期货已用/闲置/总占用：</span>
                                <span class="asset-item-progress"><MyProgress :myWidth="180" :myHeight="18" :proressWidth="apiStatics['futures_used/surplus(USDT)']"></MyProgress></span>
                                <span class="assets-item-value">{{dataProcess(apiStatics['futures_used/surplus(USDT)'])}}</span>
                            </div>
                            <div class="asset-total-item">
                                <span class="asset-item-name">永续已用/闲置/总占用：</span>
                                <span class="asset-item-progress"><MyProgress :myWidth="180" :myHeight="18" :proressWidth="apiStatics['swap_used/surplus(USDT)']"></MyProgress></span>
                                <span class="assets-item-value">{{dataProcess(apiStatics['swap_used/surplus(USDT)'])}}</span>
                            </div>
                            <div class="asset-total-item">
                                <span class="asset-item-name">借贷抵押已用/闲置/总可抵押：</span>
                                <span class="asset-item-progress"><MyProgress :myWidth="180" :myHeight="18" :proressWidth="apiStatics['borrow_pledge_used/surplus(USDT)']"></MyProgress></span>
                                <span class="assets-item-value">{{dataProcess(apiStatics['borrow_pledge_used/surplus(USDT)'])}}</span>
                            </div>
                            <div class="asset-total-item">
                                <span class="asset-item-name">净借已用/净剩余可借/净总可借：</span>
                                <span class="asset-item-progress"><MyProgress :myWidth="180" :myHeight="18" :proressWidth="apiStatics['borrow_used/surplus(USDT)']"></MyProgress></span>
                                <span class="assets-item-value">{{dataProcess(apiStatics['borrow_used/surplus(USDT)'])}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-content">
                    <table class="table">
                        <thead>
                            <tr>
                                <th v-for="(name, index) in assetsTableHeader" :key="index">{{name}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in apiTable" :key="index">
                                <td>
                                    {{item.currency}}                                     
                                </td>
                                <td>{{item.spot}}</td>
                                <td>{{item['futures']}}</td>
                                <td>{{item['P_CW']}}</td>
                                <td>{{item['P_NW']}}</td>
                                <td>{{item['P_CQ']}}</td>
                                <td>{{item['P_NQ']}}</td>
                                <td>{{item['P_CS']}}</td>
                                <td>{{item['F_CW']}}</td>
                                <td>{{item['F_NW']}}</td>
                                <td>{{item['F_CQ']}}</td>
                                <td>{{item['F_NQ']}}</td>
                                <td>{{item['F_CS']}}</td>
                                <td>{{item['wallet']}}</td>
                                <td>{{item['transfer']}}</td>
                                <td>{{item['self_worth']}}</td>
                                <td>{{item['price']}}</td>
                                <td>{{item['principal']}}</td>
                                <td>{{item['principal_usdt']}}</td>
                                <td>{{item['proportion %']}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import { mapState } from "vuex";
import { get } from "@/api/index";
import MyProgress from '@/components/My-progress.vue';
import NewProgress from '@/components/My-progress-new.vue';

export default {
    components: {
        MyProgress,
        NewProgress
    },
    data: function () {
        return {
            apiId: '',
            apiStatics: {},
            apiTable: []
        }
    },
    mounted() {
        this.apiId = this.$route.query.key;
        this.getSnapShotBoard();
    },
    computed: {
        ...mapState([
            'token',
            'assetsTableHeader'
        ]),

        // 计算(抵押已用+期货已用)/总净资产
        calUsedRate() {
            if (this.apiStatics && this.apiStatics['futures_used/surplus(USDT)'] && this.apiStatics['borrow_pledge_used/surplus(USDT)']) {
                var future_used = this.apiStatics['futures_used/surplus(USDT)'].split(':')[0];
                var borrow_used = this.apiStatics['borrow_pledge_used/surplus(USDT)'].split(':')[0];
                var total_used = this.apiStatics['total_equity(USDT)'];
                return {
                    'future': future_used,
                    'borrow': borrow_used,
                    'total': total_used
                }
            } 
            return;
        },
    },
    methods: {
        // 获取快照面板
        getSnapShotBoard() {
            var url = this.$baseUrl+'/asset/snapshot/data/get';
            get(url, {token: this.token, recordId: this.apiId}).then(res => {
                if (res.code === 200) {
                    this.apiStatics = res.data.statistics;
                    this.apiTable = res.data.list;
                } else {
                    this.$notify.error({
                        message:res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // statistic 字符串重新拼接
        dataProcess(data) {
            if (!data || typeof data !== 'string') return;
            var data_list = data.split(':');
            return data_list[0] + '/' + data_list[1] + '/' + data_list[2];
        },

        // 返回列表
        backList() {
            this.$router.go(-1);
        }
    }
}
</script>

<style lang="scss" scoped>
.snapshot-board {
    color: #a7a7a7;
    .snapshot-board-body {
        .asset-total{
            background-color: #2a2d2e;
            padding: 10px;
            .asset-total-title {
                text-align: left;
                .asset-title-item{
                    display: inline-block;
                    vertical-align: middle;
                }
            }
            .asset-total-body {
                .asset-total-item {
                    text-align: left;
                    padding: 5px 0;
                }
                .asset-total-item>span{
                    display: inline-block;
                    vertical-align: middle;
                    min-width: 220px;
                }
            }
        }

        .table-content {
            margin-top: 10px;
        }
    }

    .snapshot-title {
        button{
            margin-left: 10px;
        }
    }
}
</style>
